var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn printPage" },
    [
      _c("b-row", [
        _c(
          "div",
          { staticClass: "print-button-container" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "primary", size: "lg" },
                on: { click: _vm.printForm }
              },
              [_vm._v("Print Form")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c("h3", [
              _vm._v(
                " Commercial Sexual Exploitation Identification Tool (CSE-IT)"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [_vm._v(" Below is a summary of your responses ")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Agency/Program: ")]),
              _vm._v(_vm._s(_vm.cseit.organizationCreator.title) + " ")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Youth Code: ")]),
              _vm._v(_vm._s(_vm.cseit.person.id) + " ")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("CSE-IT Code: ")]),
              _vm._v(" " + _vm._s(_vm.cseit.id) + " ")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Youth's Age: ")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.calculateAge(
                      _vm.cseit.createdAt,
                      _vm.cseit.person.b_birthdate
                    )
                  )
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Youth's Gender Identity: ")]),
              _vm._v(_vm._s(_vm.cseit.person.b_gender_identity) + " ")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Youth's Race/Ethnicity: ")]),
              _vm._v(_vm._s(_vm.cseit.person.b_race) + " ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "1. HOUSING AND CAREGIVING.The youth experiences housing or caregiving instability for any reason."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q1),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q1) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q1)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("1"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "2. PRIOR ABUSE AND TRAUMA. The youth has experienced trauma (not including exploitation)."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q2),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q2) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q2)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("2"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "3. PHYSICAL HEALTH AND APPEARANCE.  The youth experiences notable changes in health and appearance."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q3),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q3) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q3)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("3"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "4. ENVIRONMENT AND EXPOSURE. The youth's environment and activities place them at risk for exploitation."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q4),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q4) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q4)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("4"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "5. RELATIONSHIPS AND PERSONAL BELONGINGS. The youth's relationships and personal belongings are not consistent with their age or circumstances, suggesting possible recruitment."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q5),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q5) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q5)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("5"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "6. SIGNS OF CURRENT TRAUMA. The youth exhibits signs that may result from exposure to any trauma."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q6),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q6) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q6)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("6"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "7. COERCION. The youth is being controlled or coerced by another person."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q7),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q7) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumber(_vm.cseit.calc_q7)
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("7"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "cseit-table table table-bordered",
                attrs: { cellspacing: "0" }
              },
              [
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("td", { attrs: { scope: "col" } }, [
                        _c("strong", [
                          _vm._v(
                            "8. EXPLOITATION. The youth exchanges sex for money or material goods, including food or shelter."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: _vm.calculationClass(_vm.cseit.calc_q8),
                          attrs: { scope: "col" }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_q8) +
                                " (" +
                                _vm._s(
                                  _vm.calculateSummaryNumberEight(
                                    _vm.cseit.calc_q8
                                  )
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuestions("8"), function(question, index) {
                      return _c("tr", [
                        _c("td", { attrs: { scope: "col" } }, [
                          _vm._v(
                            _vm._s(question.order.split(".")[1]) +
                              ". " +
                              _vm._s(question.questionText)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.questionAnswers[question.id]))
                        ])
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _c("td", [
                      _c("h5", [_c("strong", [_vm._v("CSE-IT Score:")])])
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        class: _vm.calculationClass(_vm.cseit.calc_cseitScore)
                      },
                      [
                        _c("h5", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cseit.calc_cseitScore) +
                                " (" +
                                _vm._s(_vm.cseitFinalScore) +
                                ")"
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c("img", {
              attrs: { src: "static/img/cseit_scale.svg", height: "75" }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "introduction-text" }, [
              _c("b", [_vm._v("Post-CSE-IT Assessment")])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c("p", [
              _vm._v(
                "Based on your professional judgment and the information available to you at the time of this CSE-IT, "
              ),
              _c("i", [
                _vm._v("including information not assessed on the CSE-IT, ")
              ]),
              _vm._v(
                "do you believe the youth is being, or has been, commercially sexually exploited? "
              )
            ]),
            _vm._v(" "),
            _c("h5", [_c("b", [_vm._v(_vm._s(_vm.cseit.judge_after))])]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.cseit.judge_whynot))]),
            _vm._v(" "),
            _vm.cseit.can_duration
              ? _c("h5", [_c("b", [_vm._v("Duration")])])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.can_duration
              ? _c("h5", [
                  _vm._v(_vm._s(_vm.capitalize(_vm.cseit.can_duration)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.can_onset
              ? _c("h5", [_c("b", [_vm._v("Onset")])])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.can_onset
              ? _c("h5", [_vm._v(_vm._s(_vm.capitalize(_vm.cseit.can_onset)))])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.can_perception
              ? _c("h5", [_c("b", [_vm._v("Perception")])])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.can_perception
              ? _c("h5", [
                  _vm._v(_vm._s(_vm.capitalize(_vm.cseit.can_perception)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.comments
              ? _c("h5", [_c("b", [_vm._v("Comments")])])
              : _vm._e(),
            _vm._v(" "),
            _vm.cseit.comments
              ? _c("h5", [_vm._v(_vm._s(_vm.cseit.comments))])
              : _vm._e(),
            _vm._v(" "),
            _c("br")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c("p", [
              _c("b", [_vm._v("Location: ")]),
              _vm._v(_vm._s(_vm.getLocationTitle(_vm.cseit.cseit_location)))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Program: ")]),
              _vm._v(_vm._s(_vm.getProgramTitle(_vm.cseit.cseit_program)))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c("p", [
              _c("b", [_vm._v("Email: ")]),
              _vm._v(_vm._s(_vm.cseit.createdBy.emailAddress))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.isUserInTX && _vm.cseit.calc_cseitScore === "Clear Concern"
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "12" } }, [
                _c("h5", { staticClass: "pt-4" }, [
                  _c("b", [_vm._v("Next Steps")])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Refer the youth for appropriate services, which may include:"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("b", [_vm._v("Care Coordination")]),
                    _vm._v(", and/or")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("b", [
                      _vm._v(
                        "Commercially Sexually Exploited Youth (CSEY) Advocacy"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("You may visit the "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://gov.texas.gov/cstt",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "Office of the Governor Child Sex Trafficking Team website"
                      )
                    ]
                  ),
                  _vm._v(
                    " to locate the Care Coordination Team and CSEY Advocate Agency in your county. If you are unsure whether Care Coordination is available in your county, or need assistance identifying the designated CSEY Advocacy provider for your region, please contact the Child Sex Trafficking Team for guidance at: "
                  ),
                  _c("a", { attrs: { href: "mailto:cstt@gov.texas.gov" } }, [
                    _vm._v("cstt@gov.texas.gov")
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-501da9ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-501da9ca","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/PrintCseit.vue
// module id = 1756
// module chunks = 0